import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, BillItemsByChargeEntryCodeController, BillItemsByChargeEntryCodeRequest, X_BillItemsController, x_BillDetailsRequest, BillDetailsInfoController, X_BillReceiptsController, X_BillHeaderController, ClinicalOrderRxItemsController, ClinicalOrderRxItemsRequest, CaseRecordSignatoryController, CaseRecordSignatoryRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest } from '../../../../../../../src/app/ncs/models/actor/actor';




@Component({
  selector: 'prescription',
  templateUrl: './prescription.component.html',
  styleUrls: ['./prescription.component.scss']
})

export class PrescriptionPVComponent implements OnInit {

    public ApiResData: ApiResponseModel;
    public isRequesting: boolean = false;

    minDate: NgbDateStruct;
    maxDate: NgbDateStruct;

    public Date: Date;
    public PatientId: string;
    public ChargeEntry: any;
    public PatientName: string;
    public PayeeName: string;
    public Toatalbill: number;
    public PaidBill: number;

    public Owner: string;
    public Gender: string;
    public Age: string;
    public BillDate: string;
    public BillNo: string;
    public Branch: string;
    public GrandTotal: string;
    public Discount: string;
    public Tax: string;
    public Net: string;
  public Due: string;

  public FacilityCode: any;
  public OrderCode: any;
  public FormattedCodedata: string;

  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.FormattedCodedata = this.route.snapshot.paramMap.get('FormattedCodedata');
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCodedata;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.LoadSign();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentCaseRecordSignatoryController: CaseRecordSignatoryController[];
  DoctorDetailsData: CaseRecordSignatoryController;
  CurrentCaseRecordSignatoryRequest: CaseRecordSignatoryRequest;



  LoadSign() {
    this.CurrentCaseRecordSignatoryRequest = new CaseRecordSignatoryRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentCaseRecordSignatoryRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.FacilityCode = this.route.snapshot.paramMap.get('FaclityCodeData');
    //this.RecordType = this.route.snapshot.paramMap.get('RecordTypeData');
    this.CurrentCaseRecordSignatoryRequest.FacilityCode = this.FacilityCode;
    //this.CurrentCaseRecordSignatoryRequest.RecordType = this.RecordType;

    this.GetCaseRecordSignatoryController();
  }
  GetCaseRecordSignatoryController() {
    this.StartRefreshing();


    this.actorservice.GetCaseRecordSignatoryController(this.CurrentCaseRecordSignatoryRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCaseRecordSignatoryController = this.ApiResData.Result;
          this.DoctorDetailsData = this.CurrentCaseRecordSignatoryController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.LoadPreDetails();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentClinicalOrderRxItemsController: ClinicalOrderRxItemsController[];

  CurrentClinicalOrderRxItemsRequest: ClinicalOrderRxItemsRequest;


  LoadPreDetails() {
    // alert("one");
    this.CurrentClinicalOrderRxItemsRequest = new ClinicalOrderRxItemsRequest();

    this.CurrentClinicalOrderRxItemsRequest.ConditionalOperator = 10;
    this.CurrentClinicalOrderRxItemsRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentClinicalOrderRxItemsRequest.OrderCode = this.OrderCode;
    this.CurrentClinicalOrderRxItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetClinicalOrderRxItemsController();

  }

  GetClinicalOrderRxItemsController() {


    // alert('loading forms: ' + this.ActorCode);
    this.StartRefreshing();
    //this.spinner.show();
    //this.CurrentPatientwiseLabReportsRequest.PatientFormattedCode = this.FormattedCode;
    //alert('loading forms: ' + this.FormattedCode);
    //this.LoadMedicalHistory_new();


    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetClinicalOrderRxItemsController(this.CurrentClinicalOrderRxItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentClinicalOrderRxItemsController = this.ApiResData.Result;
          //this.OrderDate = this.SelectedTestDetails.OrderDate;
          //this.GetTestData(this.SelectedTestDetails.OrderRequestCode);
          // this.OrderCode = this.SelectedTestDetails.OrderRequestCode;
          //this.GetTestData();
          //this.GetTestData(this.SelectedTestDetails.OrderRequestCode);

          //this.TestData = this.ApiResData.Result
          //var Testlist = this.TestData.filter(
          //    function (a) {

          //        return a.OrderDate == this.OrderDate

          //    });
          //this.TestData = Testlist;
          //alert(this.TestData.length);
          //this.spinner.hide();
          this.stopRefreshing();
          this.LoadBills();
        }
        else {
          //this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
            //this.spinner.hide();


          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
            //this.spinner.hide();
          }
        }


      );
  }

    CurrentBillItemsByChargeEntryCodeController: BillItemsByChargeEntryCodeController[];
    CurrentBillItemsByChargeEntryCodeRequest: BillItemsByChargeEntryCodeRequest;



    LoadBills() {
        this.CurrentBillItemsByChargeEntryCodeRequest = new BillItemsByChargeEntryCodeRequest();

        //alert('Checking Forma ' + this.FormattedCode);



        this.CurrentBillItemsByChargeEntryCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentBillItemsByChargeEntryCodeRequest.ChargeEntryCode = 10074;
        this.CurrentBillItemsByChargeEntryCodeRequest.ConditionalOperator = 10;
        this.GetBillItemsByChargeEntryCodeController();
    }
    GetBillItemsByChargeEntryCodeController() {
        this.StartRefreshing();


        this.actorservice.GetBillItemsByChargeEntryCodeController(this.CurrentBillItemsByChargeEntryCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentBillItemsByChargeEntryCodeController = this.ApiResData.Result;
                    //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    this.printService.onDataReady()
                    //this.LoadPatientCounsellingPlansIfAny();



                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    constructor(private router: Router,
        private actorservice: ActorService,
        private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
        private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
        private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

        public printService: PrintService) {


    }


    ngOnInit() {

        this.Date = new Date();
      this.LoadPatients();

      this.FacilityCode = this.route.snapshot.paramMap.get('FaclityCodeData');
      this.OrderCode = this.route.snapshot.paramMap.get('OrderCodedata');
      this.FormattedCodedata = this.route.snapshot.paramMap.get('FormattedCodedata');

        this.ChargeEntry = this.route.snapshot.paramMap.get('ChargeEntryData');
        this.PatientId = this.route.snapshot.paramMap.get('PatientId');

        this.Owner = this.route.snapshot.paramMap.get('Owner');
        this.Gender = this.route.snapshot.paramMap.get('Gender');
        this.Age = this.route.snapshot.paramMap.get('Age');
        this.BillDate = this.route.snapshot.paramMap.get('BillDate');
        this.BillNo = this.route.snapshot.paramMap.get('BillNo');
        this.Branch = this.route.snapshot.paramMap.get('Branch');
        this.GrandTotal = this.route.snapshot.paramMap.get('GrandTotal');
        this.Discount = this.route.snapshot.paramMap.get('Discount');
        this.Tax = this.route.snapshot.paramMap.get('Tax');
        this.Net = this.route.snapshot.paramMap.get('Net');
        this.Due = this.route.snapshot.paramMap.get('Due');

    }


    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }

}








